import HomePage from "../components/homepage/homepage";


export default function HomeView(){
    
    return (
       <HomePage />
    )
}